import { MessageCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const WhatsAppButton = ({ phone = "+393792923929", message }) => {
  const { t } = useLang();
  const msg = message || t("whatsapp.default_message");
  const href = `https://wa.me/${phone.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(msg)}`;
  return (
    <a
      data-testid="whatsapp-floating-button"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
      aria-label="Contattaci su WhatsApp"
    >
      <MessageCircle size={26} />
      <span className="absolute inset-0 rounded-full animate-ping bg-[#25D366]/40 -z-10" />
    </a>
  );
};
